import { Dropdown } from "ui-kit/components-branded/index"
import style from "modules/HRAccount/PeriodsDropdown/periods-dropdown.module.scss"

interface Props {
    period: DefaultPeriod | FixedPeriod
    onClick: (period: FixedPeriod) => void
    setInitialPeriod: () => void
    startDate: Date
}

export interface FixedPeriod {
    year: number
    start: number
    end: number | null
    label: string
}

export interface DefaultPeriod {
    label: string
}

export const initialPeriod: DefaultPeriod = {
    label: "За все время",
}

function quarter(num: 1 | 2 | 3 | 4, year: number): FixedPeriod {
    const romeNum = ["I", "II", "III", "IV"][num - 1]
    return {
        start: (num - 1) * 3,
        end: num * 3 - 1,
        label: `${romeNum} кв. ${year}`,
        year,
    }
}

function quarters(year: number, lastMonth: number): FixedPeriod[] {
    const quarters: FixedPeriod[] = []
    for (let i = 1; i <= 4; i++) {
        const q = quarter(i as 1 | 2 | 3 | 4, year)
        if (q.start <= lastMonth) {
            quarters.push(q)
        }
    }
    return quarters
}

function pastYear(year: number): FixedPeriod {
    return {
        start: 0,
        end: 11,
        label: year.toString(),
        year,
    }
}

function currentYearFromBeginning(): FixedPeriod {
    const now = new Date()
    return {
        start: 0,
        end: null,
        label: "С начала года",
        year: now.getFullYear(),
    }
}

function allPeriods(startDate: Date): FixedPeriod[] {
    const currentYear = new Date().getFullYear()
    const years = Array.from(
        { length: currentYear - startDate.getFullYear() + 1 },
        (_, i) => i + startDate.getFullYear()
    ).reverse()
    const currentMonth = new Date().getMonth()
    return years.flatMap((year) => {
        if (year === currentYear) {
            return [currentYearFromBeginning(), ...quarters(year, currentMonth)]
        }
        return pastYear(year)
    })
}

export function PeriodsDropdown({ period, startDate, onClick, setInitialPeriod }: Props) {
    return (
        <Dropdown label={period.label} triggerClassName={style.trigger}>
            <Dropdown.Item
                className="blm-dropdown__item is-highlight-on-hover"
                onClick={setInitialPeriod}
            >
                {initialPeriod.label}
            </Dropdown.Item>
            {allPeriods(startDate).map((it) => (
                <Dropdown.Item
                    className="blm-dropdown__item is-highlight-on-hover"
                    key={`periods-dropdown-item-${it.label}`}
                    onClick={() => onClick(it)}
                >
                    {it.label}
                </Dropdown.Item>
            ))}
        </Dropdown>
    )
}
